import React from 'react';
import { heroTestimonials } from '../../data/content';
import { Stars } from '../ui/Stars';
export function HeroTestimonials() {
  return <section aria-label="Testimonios destacados" className="w-full bg-ink-850" data-id="element-122" data-mp="25dp5oy3feuue">
      <div className="mx-auto grid max-w-5xl gap-6 px-5 py-16 md:grid-cols-2 md:py-20" data-id="element-123" data-mp="2a7bbq7f340h8">
        {heroTestimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl border border-ink-border bg-ink-card p-7 shadow-panel" data-id="element-124" data-mp="2f76126j7oi06">
            <Stars data-id="element-125" data-mp="1mh79o4hjo8sc" />
            <blockquote className="mt-4 flex-1 text-base italic leading-relaxed text-body" data-id="element-126" data-mp="1mgnz58u84moc">
              “{item.quote}”
            </blockquote>
            <figcaption className="mt-6 border-t border-ink-border pt-4" data-id="element-127" data-mp="1wf4x4prky1jw">
              <span className="block text-sm font-bold text-white" data-id="element-128" data-mp="32unzum0w8gcn">{item.name}</span>
              <span className="block text-sm text-subtle" data-id="element-129" data-mp="32ws0mv3hwz8p">{item.role}</span>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}